import React from 'react';

import ScheduleHeader from './ScheduleHeader';
import ScheduleCreateBody from './ScheduleCreateBody';

export default function ScheduleCreate(param) {

    return(
      <div >
        <div className="content-wrapper">
          <ScheduleHeader/>
          <ScheduleCreateBody type={param.match.params.type} projectId={param.match.params.projectId} programId={param.match.params.programId}/>
        </div>
      </div>
        


    );
}